/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/light");

var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.addJSON({
  Pick: {
    nested: {
      Content: {
        nested: {
          Condition: {
            oneofs: {
              value: {
                oneof: [
                  "age",
                  "gender",
                  "elapsed"
                ]
              }
            },
            fields: {
              sample: {
                type: "Sample",
                id: 1
              },
              comparator: {
                type: "Comparator",
                id: 2
              },
              age: {
                type: "uint32",
                id: 3
              },
              gender: {
                type: "Pick.Detection.Snapshot.Gender",
                id: 4
              },
              elapsed: {
                type: "google.protobuf.Duration",
                id: 5
              }
            },
            nested: {
              Sample: {
                values: {
                  SAMPLE_UNSPECIFIED: 0,
                  SAMPLE_AGE: 1,
                  SAMPLE_GENDER: 2,
                  SAMPLE_ELAPSED: 3
                }
              },
              Comparator: {
                values: {
                  COMPARATOR_UNSPECIFIED: 0,
                  COMPARATOR_EQ: 1,
                  COMPARATOR_NE: 2,
                  COMPARATOR_GT: 3,
                  COMPARATOR_LT: 4,
                  COMPARATOR_LE: 5,
                  COMPARATOR_GE: 6
                }
              }
            }
          },
          Trigger: {
            fields: {
              matchUid: {
                type: "string",
                id: 1
              },
              conditions: {
                rule: "repeated",
                type: "Condition",
                id: 2
              }
            }
          },
          Content: {
            fields: {
              uid: {
                type: "string",
                id: 1
              },
              url: {
                type: "string",
                id: 2
              },
              index: {
                type: "uint32",
                id: 3
              },
              playLimit: {
                type: "uint32",
                id: 4
              },
              type: {
                type: "Type",
                id: 5
              },
              order: {
                type: "Order",
                id: 6
              },
              triggers: {
                rule: "repeated",
                type: "Trigger",
                id: 7
              }
            },
            nested: {
              Type: {
                values: {
                  TYPE_UNSPECIFIED: 0,
                  TYPE_VIDEO: 1,
                  TYPE_IMAGE: 2
                }
              },
              Order: {
                values: {
                  ORDER_UNSPECIFIED: 0,
                  ORDER_PRIMARY: 1,
                  ORDER_SECONDARY: 2
                }
              }
            }
          },
          Playback: {
            fields: {
              contentUid: {
                type: "string",
                id: 1
              },
              order: {
                type: "Content.Order",
                id: 2
              },
              timestamp: {
                type: "google.protobuf.Timestamp",
                id: 3
              }
            }
          },
          Playlist: {
            fields: {
              uid: {
                type: "string",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              owner: {
                type: "string",
                id: 3
              },
              contents: {
                rule: "repeated",
                type: "Content",
                id: 4
              }
            }
          },
          Schedule: {
            fields: {
              uid: {
                type: "string",
                id: 1
              },
              startDate: {
                type: "string",
                id: 2
              },
              endDate: {
                type: "string",
                id: 3
              },
              startTime: {
                type: "string",
                id: 4
              },
              endTime: {
                type: "string",
                id: 5
              },
              pattern: {
                type: "Pattern",
                id: 6
              },
              playlist: {
                type: "Playlist",
                id: 7
              },
              nonstop: {
                type: "bool",
                id: 8
              }
            },
            nested: {
              Pattern: {
                values: {
                  PATTERN_UNSPECIFIED: 0,
                  PATTERN_DAILY: 1,
                  PATTERN_WEEKDAY: 2,
                  PATTERN_WEEKEND: 3
                }
              }
            }
          }
        }
      },
      Detection: {
        nested: {
          Network: {
            fields: {},
            nested: {
              Type: {
                values: {
                  TYPE_UNSPECIFIED: 0,
                  TYPE_DETECTOR_HEAD: 1,
                  TYPE_DETECTOR_FACE: 2,
                  TYPE_DETECTOR_HAND: 3,
                  TYPE_CLASSIFIER_COVER: 24,
                  TYPE_CLASSIFIER_AGE: 25,
                  TYPE_CLASSIFIER_GENDER: 26
                }
              }
            }
          },
          Hand: {
            fields: {
              bbox: {
                type: "Pick.Core.Bbox",
                id: 1
              }
            }
          },
          Face: {
            fields: {
              gaze: {
                type: "Pick.Core.XY",
                id: 1
              },
              pose: {
                type: "Pick.Core.XYZ",
                id: 2
              },
              euler: {
                type: "Pick.Core.XYZ",
                id: 3
              }
            }
          },
          Snapshot: {
            fields: {
              uid: {
                type: "uint64",
                id: 1
              },
              timestamp: {
                type: "google.protobuf.Timestamp",
                id: 2
              },
              elapsed: {
                type: "google.protobuf.Duration",
                id: 3
              },
              age: {
                type: "uint32",
                id: 4
              },
              gender: {
                type: "Gender",
                id: 6
              },
              bbox: {
                type: "Pick.Core.Bbox",
                id: 7
              },
              face: {
                type: "Face",
                id: 8
              },
              covered: {
                type: "Covered",
                id: 9
              }
            },
            reserved: [
              [
                5,
                5
              ]
            ],
            nested: {
              Gender: {
                values: {
                  GENDER_UNSPECIFIED: 0,
                  GENDER_FEMALE: 1,
                  GENDER_MALE: 2
                }
              },
              AgeGroup: {
                values: {
                  AGE_GROUP_UNSPECIFIED: 0,
                  AGE_GROUP_TEEN: 1,
                  AGE_GROUP_YOUNG: 2,
                  AGE_GROUP_ADULT: 3,
                  AGE_GROUP_SENIOR: 4
                }
              },
              Covered: {
                values: {
                  COVERED_UNSPECIFIED: 0,
                  COVERED_NO_FACE: 1,
                  COVERED_COVERED: 2,
                  COVERED_UNCOVERED: 3
                }
              }
            }
          },
          SnapshotVector: {
            fields: {
              snapshots: {
                rule: "repeated",
                type: "Snapshot",
                id: 1
              }
            }
          },
          Attention: {
            fields: {
              passed: {
                type: "bool",
                id: 1
              },
              looked: {
                type: "bool",
                id: 2
              },
              interested: {
                type: "bool",
                id: 3
              },
              focused: {
                type: "bool",
                id: 4
              },
              touched: {
                type: "bool",
                id: 5
              }
            }
          },
          Session: {
            fields: {
              uid: {
                type: "uint64",
                id: 1
              },
              duration: {
                type: "google.protobuf.Duration",
                id: 2
              },
              startTimestamp: {
                type: "google.protobuf.Timestamp",
                id: 3
              },
              stopTimestamp: {
                type: "google.protobuf.Timestamp",
                id: 4
              },
              attention: {
                type: "Attention",
                id: 5
              },
              gazeFlow: {
                rule: "repeated",
                type: "Pick.Core.XY",
                id: 6
              },
              age: {
                type: "uint32",
                id: 7
              },
              gender: {
                type: "Snapshot.Gender",
                id: 9
              },
              covered: {
                type: "Snapshot.Covered",
                id: 10
              },
              attentionDuration: {
                type: "google.protobuf.Duration",
                id: 11
              }
            },
            reserved: [
              [
                8,
                8
              ]
            ]
          },
          SessionVector: {
            fields: {
              sessions: {
                rule: "repeated",
                type: "Session",
                id: 1
              }
            }
          }
        }
      },
      Core: {
        nested: {
          XY: {
            fields: {
              x: {
                type: "double",
                id: 1
              },
              y: {
                type: "double",
                id: 2
              }
            }
          },
          XYZ: {
            fields: {
              x: {
                type: "double",
                id: 1
              },
              y: {
                type: "double",
                id: 2
              },
              z: {
                type: "double",
                id: 3
              }
            }
          },
          Bbox: {
            fields: {
              left: {
                type: "double",
                id: 1
              },
              top: {
                type: "double",
                id: 2
              },
              right: {
                type: "double",
                id: 3
              },
              bottom: {
                type: "double",
                id: 4
              }
            }
          },
          Region: {
            fields: {
              uid: {
                type: "int32",
                id: 1
              },
              name: {
                type: "string",
                id: 3
              },
              center: {
                type: "XY",
                id: 2
              }
            }
          },
          Calibration: {
            fields: {
              regions: {
                rule: "repeated",
                type: "Region",
                id: 1
              }
            }
          }
        }
      },
      Device: {
        nested: {
          Config: {
            fields: {
              hash: {
                type: "string",
                id: 1
              },
              schedules: {
                rule: "repeated",
                type: "Pick.Content.Schedule",
                id: 2
              },
              calibration: {
                type: "Pick.Core.Calibration",
                id: 3
              },
              mode: {
                type: "Mode",
                id: 4
              }
            },
            nested: {
              Mode: {
                values: {
                  MODE_UNSPECIFIED: 0,
                  MODE_DEMO: 1,
                  MODE_PLAYER: 2,
                  MODE_ANALYSIS: 3,
                  MODE_GAZE: 4
                }
              }
            }
          },
          State: {
            fields: {
              capture: {
                type: "Capture",
                id: 1
              },
              display: {
                type: "Display",
                id: 2
              },
              media: {
                type: "Media",
                id: 3
              },
              mode: {
                type: "Config.Mode",
                id: 4
              }
            },
            nested: {
              Capture: {
                values: {
                  CAPTURE_UNSPECIFIED: 0,
                  CAPTURE_OPENED: 1,
                  CAPTURE_CLOSED: 2,
                  CAPTURE_ERROR: 3
                }
              },
              Display: {
                values: {
                  DISPLAY_UNSPECIFIED: 0,
                  DISPLAY_POWERED: 1,
                  DISPLAY_UNPOWERED: 2,
                  DISPLAY_ERROR: 3
                }
              },
              Media: {
                values: {
                  MEDIA_UNSPECIFIED: 0,
                  MEDIA_IDLE: 1,
                  MEDIA_STOPPED: 2,
                  MEDIA_PLAYING: 3,
                  MEDIA_PAUSED: 4,
                  MEDIA_ERROR: 5
                }
              }
            }
          },
          LogRecord: {
            fields: {
              level: {
                type: "Level",
                id: 1
              },
              origin: {
                type: "Origin",
                id: 2
              },
              message: {
                type: "string",
                id: 3
              },
              timestamp: {
                type: "google.protobuf.Timestamp",
                id: 4
              }
            },
            nested: {
              Level: {
                options: {
                  allow_alias: true
                },
                values: {
                  LEVEL_UNSPECIFIED: 0,
                  LEVEL_NOTSET: 0,
                  LEVEL_DEBUG: 10,
                  LEVEL_INFO: 20,
                  LEVEL_WARN: 30,
                  LEVEL_WARNING: 30,
                  LEVEL_ERROR: 40,
                  LEVEL_FATAL: 50,
                  LEVEL_CRITICAL: 50
                }
              },
              Origin: {
                values: {
                  ORIGIN_UNSPECIFIED: 0,
                  ORIGIN_NOTTI: 1,
                  ORIGIN_QPICK: 2,
                  ORIGIN_REDIS: 3,
                  ORIGIN_SIPHON: 4
                }
              }
            }
          },
          Stats: {
            fields: {
              eventCount: {
                type: "int32",
                id: 1
              },
              playbackCount: {
                type: "int32",
                id: 2
              },
              errorCount: {
                type: "int32",
                id: 3
              }
            }
          },
          Device: {
            fields: {
              uid: {
                type: "string",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              owner: {
                type: "string",
                id: 3
              },
              online: {
                type: "bool",
                id: 4
              },
              active: {
                type: "bool",
                id: 5
              },
              config: {
                type: "Config",
                id: 6
              },
              state: {
                type: "State",
                id: 7
              },
              stats: {
                type: "Stats",
                id: 8
              }
            }
          }
        }
      },
      Report: {
        nested: {
          ReportInfo: {
            fields: {
              type: {
                type: "Type",
                id: 1
              },
              deviceId: {
                type: "string",
                id: 2
              },
              timestamp: {
                type: "google.protobuf.Timestamp",
                id: 4
              }
            },
            nested: {
              Type: {
                values: {
                  TYPE_UNSPECIFIED: 0,
                  TYPE_DETECTION: 1,
                  TYPE_GENDER: 2,
                  TYPE_GAZE: 3
                }
              }
            }
          },
          DetectionData: {
            fields: {
              pass: {
                type: "Pick.Core.XY",
                id: 1
              },
              look: {
                type: "Pick.Core.XY",
                id: 2
              },
              interest: {
                type: "Pick.Core.XY",
                id: 3
              },
              focus: {
                type: "Pick.Core.XY",
                id: 4
              },
              touch: {
                type: "Pick.Core.XY",
                id: 5
              }
            }
          },
          DetectionReport: {
            fields: {
              info: {
                type: "ReportInfo",
                id: 1
              },
              data: {
                type: "DetectionData",
                id: 2
              }
            }
          },
          GenderDataModel: {
            fields: {
              pass: {
                rule: "repeated",
                type: "int32",
                id: 1
              },
              look: {
                rule: "repeated",
                type: "int32",
                id: 2
              },
              interest: {
                rule: "repeated",
                type: "int32",
                id: 3
              },
              focus: {
                rule: "repeated",
                type: "int32",
                id: 4
              },
              touch: {
                rule: "repeated",
                type: "int32",
                id: 5
              }
            }
          },
          GenderData: {
            fields: {
              female: {
                type: "GenderDataModel",
                id: 1
              },
              male: {
                type: "GenderDataModel",
                id: 2
              }
            }
          },
          GenderReport: {
            fields: {
              info: {
                type: "ReportInfo",
                id: 1
              },
              data: {
                type: "GenderData",
                id: 2
              }
            }
          },
          GazeData: {
            fields: {
              uid: {
                type: "uint64",
                id: 1
              },
              duration: {
                type: "google.protobuf.Duration",
                id: 2
              },
              timestamp: {
                type: "google.protobuf.Timestamp",
                id: 3
              },
              flow: {
                rule: "repeated",
                type: "Pick.Core.XY",
                id: 4
              }
            }
          },
          GazeReport: {
            fields: {
              info: {
                type: "ReportInfo",
                id: 1
              },
              data: {
                rule: "repeated",
                type: "GazeData",
                id: 2
              }
            }
          }
        }
      }
    }
  },
  google: {
    nested: {
      protobuf: {
        nested: {
          Duration: {
            fields: {
              seconds: {
                type: "int64",
                id: 1
              },
              nanos: {
                type: "int32",
                id: 2
              }
            }
          },
          Timestamp: {
            fields: {
              seconds: {
                type: "int64",
                id: 1
              },
              nanos: {
                type: "int32",
                id: 2
              }
            }
          }
        }
      }
    }
  }
});

module.exports = $root;
